import { DepositLimitCalculatorEvent } from "@obg/mat.ui.common/public-api";
import { RESPONSIBLE_GAMING_ROUTE } from "@obg/ngx.core";

export interface GmtEventsDictionary {
	[key: string]: { event: string };
}

export const RESPONSIBLE_GAMING_UNSAVED_CHANGES_ALERT_ID = "RESPONSIBLE_GAMING_UNSAVED_CHANGES_ALERT_ID";

export const RESPONSIBLE_GAMING_ROUTES = [
	RESPONSIBLE_GAMING_ROUTE.information,
	RESPONSIBLE_GAMING_ROUTE.bettingLimit,
	RESPONSIBLE_GAMING_ROUTE.netlossLimit,
	RESPONSIBLE_GAMING_ROUTE.depositLimit,
	RESPONSIBLE_GAMING_ROUTE.depositLimitCalculator,
	RESPONSIBLE_GAMING_ROUTE.depositLimitDialog,
	RESPONSIBLE_GAMING_ROUTE.balanceLimit,
	RESPONSIBLE_GAMING_ROUTE.selfExclusion,
	RESPONSIBLE_GAMING_ROUTE.realityCheck,
	RESPONSIBLE_GAMING_ROUTE.selfAssessment,
	RESPONSIBLE_GAMING_ROUTE.timeOff,
	RESPONSIBLE_GAMING_ROUTE.sessionLimit,
	RESPONSIBLE_GAMING_ROUTE.sessionLimitDialog,
	RESPONSIBLE_GAMING_ROUTE.selectPlayerProfile,
	RESPONSIBLE_GAMING_ROUTE.loginLimit,
];

export const DEPOSIT_LIMIT_CALCULATOR = "deposit-limit-calculator";

export const ROUTE_ACCORDION_KEY_DICTIONARY = {
	[RESPONSIBLE_GAMING_ROUTE.depositLimitCalculator]: DEPOSIT_LIMIT_CALCULATOR,
};

export const GTM_EVENTS_DICTIONARY: GmtEventsDictionary = {
	[DEPOSIT_LIMIT_CALCULATOR]: { event: DepositLimitCalculatorEvent.LinkClick },
};
